import React, { Component } from 'react';
import Cookies from 'js-cookie';
import translate from './TranslateHOC';
import Isvg from 'react-inlinesvg';
import clic_play from '../img/icons/clic_play.svg';
import { connect } from 'react-redux';
import { show } from 'redux-modal';
import { bindActionCreators } from 'redux';
import { checkLang, IsvgWrapper } from '../helpers';
import { disableAds, stingAds, isVideoPlayerInstance } from '../player_helpers';
import IsLoadingAnim from './alerts/IsLoadingAnim';
import {
  PLAYER_LIVE,
  PLAYER_OD,
  PLAYER_EXC,
  AD_BLOCK_DIALOG,
  PLAYER_STATE_ACTIVE,
  PLAYER_STATE_END,
  PLAYER_EVENTS_LOADED,
  PLAYER_ERROR_EVENT,
  PLAYER_EVENTS_ENDED,
  PLAYER_STATE_LOADING,
  PLAYER_ERROR_DIALOG,
  PLAYER_CYWTIWB,
  PLAYER_EVENTS_PLAYING,
  PLAYER_EVENTS_PROG_CHANGE,
  PLAYER_EVENTS_SCHED_CHANGE,
  SHORTCUT_DIALOG,
  GDPR_COOKIE,
  PLAYER_SSAI,
  PLAYER_CYWTIWB_POSTER_DEFAULT,
  DEFAULT_IMG_LAND_1280,
  EXTRA_FEED_POSTER_URL
} from '../constants';
import AdBlockerDialog from './player/modals/AdBlockerDialog';
import PlayerErrorDialog from './player/modals/PlayerErrorDialog';

class Player extends Component {
  /**
   * Player wraps 4 types of playback:
   * od - on-demand - prog is expected
   * live - use default stream
   * exclusive - online exclusive - excStream is expected
   * cywtiwb -
   *
   * This wrapper is preventing a second player config from being triggered before a first is complete
   * as this generates two streams in the same player
   *
   * The wrapper recieves the curLang for prop changes but is now relying directly on the checkLang localstorage
   * as it avoid the glitch when loading en as cy is the default before curlang is resolved corrcetly.
   * TODO: curlang should be correct before components are generated
   *
   * Listening to two key events - config loaded which is at a window level and ended on a player and play ended
   *
   * Update: 20191223
   * delayrequired is used to allow a re-render of the video tag following a cleanup.
   * So for example if the player is used as one type and then new props land to switch type then the delay is needed
   * This is different from the previous version of the player as video tag was added dyanmically
   *
   * Update: 20231116
   * GDPR IAB TCF compliance. Integration of CookieYes CMP
   * Check for advertising consent, pass on related TCF string if so
   */

  constructor() {
    super();
    this.state = {
      currentLang: null,
      currentProgID: null,
      currentSigned: null,
      isDisplayed: true,
      isPlayerLoaded: false,
      isConfigLoaded: false,
      showShortcut: false,
    };

    this.handleAdDialogClose = this.handleAdDialogClose.bind(this);
    this.handlePlayEnded = this.handlePlayEnded.bind(this);
    this.handleConfigLoaded = this.handleConfigLoaded.bind(this);
    this.handleProgChange = this.handleProgChange.bind(this);
    this.handleSchedChange = this.handleSchedChange.bind(this);
    this.handlePlayerErrorModal = this.handlePlayerErrorModal.bind(this);
    this.handlePlayerSubtitles = this.handlePlayerSubtitles.bind(this);
    this.addPlayerSubtitlesListener =
      this.addPlayerSubtitlesListener.bind(this);
    this.removePlayerSubtitleListener =
      this.removePlayerSubtitleListener.bind(this);
    this.getGDPR = this.getGDPR.bind(this);

    // Due complex nature of config loading the following are needed in addition to the state versions
    this.isLoadingConfig = false;
    this.isReTriggerConfig = false;
    this.delayRequired = false;
  }

  removePlayerListener = () => {
    window.removeEventListener(PLAYER_EVENTS_LOADED, this.handleConfigLoaded);
    window.removeEventListener(PLAYER_ERROR_EVENT, this.handlePlayerErrorModal);
    window.removeEventListener(PLAYER_EVENTS_ENDED, this.handlePlayEnded);
    window.removeEventListener(
      PLAYER_EVENTS_PROG_CHANGE,
      this.handleProgChange
    );
    window.removeEventListener(
      PLAYER_EVENTS_SCHED_CHANGE,
      this.handleSchedChange
    );
  };
  addPlayerListener = () => {
    window.addEventListener(PLAYER_EVENTS_LOADED, this.handleConfigLoaded);
    window.addEventListener(PLAYER_ERROR_EVENT, this.handlePlayerErrorModal);
    window.addEventListener(PLAYER_EVENTS_ENDED, this.handlePlayEnded);
    document.addEventListener(PLAYER_EVENTS_PROG_CHANGE, this.handleProgChange);
    window.addEventListener(PLAYER_EVENTS_SCHED_CHANGE, this.handleSchedChange);
  };

  getGDPR = () => {
    const GDPRConsent = Cookies.get(GDPR_COOKIE) || null;
    const GDPR = GDPRConsent ? '1' : '0';

    return { GDPR, GDPRConsent };
  };

  /* Subtitles functions here */
  addPlayerSubtitlesListener = () => {
    if (isVideoPlayerInstance()) {
      let vidJSPlayer = window.videojs(window.playerOptions.video_id);
      if (vidJSPlayer) {
        vidJSPlayer.on(PLAYER_EVENTS_PLAYING, this.props.handleSubtitlesLoaded);
      }
    }
  };
  removePlayerSubtitleListener = () => {
    if (isVideoPlayerInstance()) {
      let vidJSPlayer = window.videojs(window.playerOptions.video_id);
      if (vidJSPlayer) {
        vidJSPlayer.off(
          PLAYER_EVENTS_PLAYING,
          this.props.handleSubtitlesLoaded
        );
      }
    }
  };
  handlePlayerSubtitles = () => {
    if (isVideoPlayerInstance()) {
      if (window.videojs(window.playerOptions.video_id)) {
        const vidJSPlayer = window
          .videojs(window.playerOptions.video_id)
          .textTracks();
        vidJSPlayer.addEventListener(
          'change',
          this.props.handlePlayerSubtitlesChange
        );
      }
    }
  };

  handlePlayEnded = (event) => {
    this.props.onChange && this.props.onChange(PLAYER_STATE_END);
  };

  handleProgChange = (event) => {
    this.props.handleUpdateProgDetails &&
      this.props.handleUpdateProgDetails(event.detail);
  };
  handleSchedChange = (event) => {
    console.log('----------------------------');
    console.log('`scheduleChange` event fired');
    console.log('----------------------------');
    this.props.handleUpdateProgDetails &&
      this.props.handleUpdateProgDetails(event.detail);
  };

  handleConfigLoaded = () => {
    this.isLoadingConfig = false;
    if (this.isReTriggerConfig) {
      this.isReTriggerConfig = false;
      this.triggerConfigLoad();
    } else {
      console.log('--CONFIG LOADED--');
      console.log('isTriggerConfigLoad::' + this.props.isTriggerConfigLoad);
      console.log('isTriggerAutoPlay::' + this.props.isTriggerAutoPlay);
      this.setState({ isConfigLoaded: true });
      if (this.props.isTriggerAutoPlay === true) {
        window.PlayerManager.play(); //only play if nothing else coming and is requested
      }
    }
    if (this.props.type === PLAYER_OD) {
      this.handlePlayerSubtitles();
      this.addPlayerSubtitlesListener();
    }
    this.props.onChange && this.props.onChange(PLAYER_STATE_ACTIVE); //triggered on player first load
  };

  handlePlayerErrorModal = (event) => {
    if (event.detail && event.detail.code) {
      this.props.show(PLAYER_ERROR_DIALOG, {
        message: event.detail.message,
        code: event.detail.code,
        handleClose: this.handleAdDialogClose,
      });
    }
  };

  triggerConfigLoad = () => {
    this.setState({ isConfigLoaded: false });
    // if there is already config loading then prevent another
    // playback until it's loaded
    if (this.isLoadingConfig) {
      this.isReTriggerConfig = true;
    } else {
      // This fix was needed to allow the DOM to re-render before triggering load - why??
      if (this.delayRequired) {
        this.delayRequired = false;
        this.setState({
          isDisplayed: false,
        });
      } else {
        if (!window.Util.checkAdBlock()) {
          this.isLoadingConfig = true;
          window.PlayerManager.loadConfig();
          this.props.onChange && this.props.onChange(PLAYER_STATE_LOADING);
        }
      }
    }
  };

  toggleShortcutPrompt = (e) => {
    this.props.show(SHORTCUT_DIALOG, {});
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (!this.state.isDisplayed) {
      this.setState({ isDisplayed: true });
      this.triggerConfigLoad();
    }
  };

  showAdDialog = () => {
    this.props.show(AD_BLOCK_DIALOG, {
      handleClose: this.handleAdDialogClose,
    });
  };

  handleAdDialogClose = () => {};

  updateLangState = (lang) => {
    this.setState({
      currentLang: lang,
    });
  };

  setLiveConfig = () => {
    this.updateLangState(checkLang());
    var obj = {};
    obj.lang = checkLang();
    const { GDPR, GDPRConsent } = this.getGDPR();
    obj.GDPR = GDPR;
    obj.GDPRConsent = GDPRConsent;
    obj.SSAI = PLAYER_SSAI;
    window.PlayerConfigBuilder.buildConfig(PLAYER_LIVE, obj);
  };
  setCywTiwbConfig = () => {
    this.updateLangState(checkLang());
    var obj = {};
    obj.lang = checkLang();
    window.PlayerConfigBuilder.buildConfig(PLAYER_CYWTIWB, obj);
  };
  setExclusivesConfig = (
    streamName,
    streamingUrl,
    streamTitle,
    streamImg,
    adhocStartDate,
    adhocStartTime,
    adhocEndDate,
    adhocEndTime,
    timeShifted
  ) => {
    this.updateLangState(checkLang());
    var obj = {};
    obj.streamName = streamName;
    obj.streamingUrl = streamingUrl;
    obj.series_title = streamTitle;
    obj.poster = streamImg;
    obj.adhocStartDate = adhocStartDate;
    obj.adhocStartTime = adhocStartTime;
    obj.adhocEndDate = adhocEndDate;
    obj.adhocEndTime = adhocEndTime;
    obj.timeShifted = timeShifted;
    window.PlayerConfigBuilder.buildConfig(PLAYER_EXC, obj);
  };
  setODConfig = (
    prog,
    stingSeries,
    stingProgramme,
    stingCat,
    advertsDisable,
    signed,
    progResume,
    mode,
    recommendationId
  ) => {
    const signedChecked = signed && parseInt(signed, 10) === 1 ? signed : 0;
    const stingId = stingAds(
      stingSeries,
      stingProgramme,
      stingCat,
      prog.series_id,
      prog.id,
      prog.genre_ids
    );

    this.setState({
      currentLang: checkLang(),
      currentProgID: prog.id,
      currentSigned: signedChecked,
    });

    const { GDPR, GDPRConsent } = this.getGDPR();

    var config = {};
    config.lang = checkLang();
    config.programmeId = prog.id;
    config.playerPosition =
      progResume.playerPosition === undefined ? 0 : progResume.playerPosition;
    config.subtitles =
      progResume.subtitles === undefined ? 0 : progResume.subtitles;
    config.audioTrack =
      progResume.audioTrack === undefined ? 0 : progResume.audioTrack;
    config.signed = signedChecked;
    config.stingId = stingId;
    config.mode = mode;
    config.disableAds = disableAds(advertsDisable, prog.genre_ids.split(','));
    /* Add recommendationId to config if available */
    if (recommendationId && recommendationId.length > 0) {
      config.recommendationId = recommendationId;
    }

    config.GDPR = GDPR;
    config.GDPRConsent = GDPRConsent;

    /* Add the mid rolls data */
    if (prog.has_midrolls) {
      config.adMidrolls = prog.has_midrolls;
      config.adMidrollsTimings = prog.midroll_timings;
    }

    window.PlayerConfigBuilder.buildConfig(PLAYER_OD, config);
  };

  initialisePlayer = (type, props) => {
    window.console.log('initialisePlayer');
    switch (type) {
      case PLAYER_LIVE:
        window.console.log('initialisePlayer::LIVE');
        this.setLiveConfig();
        this.isLoadingConfig = false;
        this.triggerConfigLoad();
        break;
      case PLAYER_CYWTIWB:
        window.console.log('initialisePlayer::PLAYER_CYWTIWB');
        this.setCywTiwbConfig();
        this.isLoadingConfig = false;
        this.triggerConfigLoad();
        break;
      case PLAYER_EXC:
        if (props.excStreamClean && props.excStreamClean.length > 0) {
          window.console.log('initialisePlayer::PLAYER_EXC');
          this.setExclusivesConfig(
            props.excStreamClean,
            props.streamingUrl,
            props.streamTitle,
            props.streamImg,
            props.adhocStartDate,
            props.adhocStartTime,
            props.adhocEndDate,
            props.adhocEndTime,
            props.timeShifted
          );
          this.isLoadingConfig = false;
          this.triggerConfigLoad();
        }
        break;
      case PLAYER_OD:
        window.console.log('initialisePlayer::PLAYER_OD');
        this.setODConfig(
          props.prog,
          props.stingSeries,
          props.stingProgramme,
          props.stingCat,
          props.advertsDisable,
          props.signed,
          props.progResume,
          PLAYER_OD,
          props.recommendationId
        );
        this.isLoadingConfig = false;
        if (props.isTriggerConfigLoad) {
          // due to the playerloading its now possible to have an OD already marked as isTriggerConfigLoad
          this.triggerConfigLoad();
        }
        break;
      default:
        break;
    }
  };

  updateODRequired = (nextProps) => {
    return (
      nextProps.prog.id &&
      (this.state.currentLang !== checkLang() ||
        this.state.currentProgID !== nextProps.prog.id || // prog ID changed
        this.state.currentSigned !== nextProps.signed)
    ); // signed status changed
  };

  componentDidMount = () => {
    if (window.Util.checkAdBlock()) {
      this.showAdDialog();
    } else {
      window.Util.loadPlayer(this.playerLoaded);
    }
  };

  playerLoaded = () => {
    this.setState({ isPlayerLoaded: true });
    this.addPlayerListener();
    this.initialisePlayer(this.props.type, this.props);
  };

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    let nextLang = checkLang();
    switch (nextProps.type) {
      case PLAYER_OD:
        if (this.state.isPlayerLoaded) {
          if (this.updateODRequired(nextProps)) {
            this.initialisePlayer(PLAYER_OD, nextProps);
            // only trigger config load if isTriggerConfigLoad state
            if (nextProps.isTriggerConfigLoad) {
              this.triggerConfigLoad();
            }
          } else if (
            this.state.currentProgID &&
            nextProps.isTriggerConfigLoad &&
            !this.props.isTriggerConfigLoad
          ) {
            // if load is selected and it wasn't previously
            this.triggerConfigLoad();
          }
        }
        break;
      case PLAYER_LIVE:
        if (
          this.props.type !== PLAYER_LIVE ||
          this.state.currentLang !== nextLang
        ) {
          this.delayRequired = true;
          this.initialisePlayer(PLAYER_LIVE, nextProps);
        }
        break;
      case PLAYER_CYWTIWB:
        if (
          this.props.type !== PLAYER_CYWTIWB ||
          (this.state.currentLang !== null && this.state.currentLang !== nextLang)
        ) {
          this.delayRequired = true;
          this.initialisePlayer(PLAYER_CYWTIWB, nextProps);
        }
        break;
      case PLAYER_EXC:
        if (
          (nextProps.excStream &&
            this.props.excStream !== nextProps.excStream) ||
          this.props.extraFeedPath !== nextProps.extraFeedPath
        ) {
          this.delayRequired = true;
          window.PlayerManager.cleanup();
          this.initialisePlayer(PLAYER_EXC, nextProps);
        }
        break;
      default:
        break;
    }
  };

  componentWillUnmount = () => {
    this.removePlayerListener();
    if (this.props.type === PLAYER_OD) {
      this.removePlayerSubtitleListener();
      // } else {
      //   this.removeProgChangeListener();
    }
    window.PlayerManager.cleanup();
    this.isLoadingConfig = false;
    this.isReTriggerConfig = false;
  };

  render() {
    const trans = this.props.strings;
    const playerLoaded =
      this.state.isPlayerLoaded && this.state.isDisplayed
        ? ''
        : 'playerLoading';
    const configLoaded = this.state.isConfigLoaded
      ? 'configLoaded'
      : 'configLoading';

    let title, subTitle, backgroundStyle;
    let backgroundImage = this.props.type === PLAYER_CYWTIWB ? PLAYER_CYWTIWB_POSTER_DEFAULT : DEFAULT_IMG_LAND_1280;

    if (this.props.prog) {
      title = this.props.prog.series_title
        ? this.props.prog.series_title
        : this.props.prog.programme_title;

      subTitle = this.props.prog.series_title
        ? this.props.prog.programme_title
          ? this.props.prog.programme_title
          : this.props.prog.clic_aired
        : this.props.prog.clic_aired;

      backgroundStyle = {
        backgroundImage: `url(${this.props.prog.thumbnail_url ? EXTRA_FEED_POSTER_URL + this.props.prog.thumbnail_url : backgroundImage })`,
      };
    }

    if (this.props.streamTitle) {
      title = this.props.streamTitle;
    }

    if (this.props.title) {
      title = this.props.title;
    }

    return (
      <div className={`player ${playerLoaded} ${configLoaded}`}>
        <PlayerErrorDialog />
        <AdBlockerDialog trans={trans} />
        {this.state.isDisplayed && (
          <section className="playerSection">
            <div className="playerHead mainContentInner" />

            <div className="playerHolder">
              <div className="playerHolderInner">
                <div
                  id="player"
                  className="display-player"
                  style={backgroundStyle}
                >
                  <div className="playerPlayOverlay">
                    <IsvgWrapper addClasses="icon">
                      <Isvg src={clic_play} />
                    </IsvgWrapper>
                  </div>

                  <div className="playerLoadingOverlay">
                    <IsLoadingAnim />
                  </div>

                  <div className="playerOverlay">
                    <h2 className="playerOverlayTitle">{title}</h2>
                    <h3 className="playerOverlaySubTitle">{subTitle}</h3>
                  </div>

                  <video
                    id="s4c-player"
                    className="vjs-fill video-js vjs-default-skin s4c-skin"
                    controls
                  >
                    <p className="vjs-no-js">
                      To view this video please enable JavaScript, and consider
                      upgrading to a web browser that
                      <a
                        href="http://videojs.com/html5-video-support/"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {' '}
                        supports HTML5 video{' '}
                      </a>
                    </p>
                  </video>
                </div>
              </div>
            </div>
          </section>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    show: bindActionCreators(show, dispatch),
  };
};

export default translate(connect(null, mapDispatchToProps)(Player));
